import React, { useState, useEffect } from "react";
import ReactPlayer from 'react-player'
import { projectFirestore } from '../firebase/config';

const DEFAULT_VIDEO = 'https://www.youtube.com/watch?v=Rz1H_AaoBg8';

export default function Video() {
    const [videoUrl, setVideoUrl] = useState(DEFAULT_VIDEO);

    useEffect(() => {
        const unsub = projectFirestore.collection('settings').doc('site')
            .onSnapshot((doc) => {
                if (doc.exists && doc.data().videoUrl) {
                    setVideoUrl(doc.data().videoUrl);
                }
            });
        return () => unsub();
    }, []);

    return (
      <> 
            <p className="d-flex justify-content-center align-items-center 0 " >
            <ReactPlayer url={videoUrl} controls='true' playing='true' />
            </p> 
        </>
      );
    }
    
